import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    paddingBottom: theme.spacing.xxSmall,
    textAlign: "center",
}));

export const ImageContainer = styled.div<{ $height: number }>(({ theme, $height }) => ({
    marginLeft: `calc(-1 * ${theme.spacing.medium})`,
    marginTop: `calc(-1 * ${theme.spacing.medium})`,
    width: `calc(100% + 2 * ${theme.spacing.medium})`,
    height: `${$height}px`,
}));

export const InfoContainer = styled.div(({ theme }) => ({
    display: "flex",
    paddingTop: `calc(${theme.spacing.xxxSmall} + ${theme.spacing.xSmall})`,
}));

export const InfoText = styled(Text)(({ theme }) => ({
    marginLeft: theme.spacing.xSmall,
}));

export const ActionContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xLarge,
    marginBottom: theme.spacing.medium,
    width: "100%",
    display: "grid",
    gridAutoFlow: "column",
    gridGap: theme.spacing.small,
    gridTemplateColumns: "1fr 1fr",
}));

export const FullSuperButton = styled(SuperButton)({
    width: "100%",
});
